import React, { Component } from 'react';
import PropTypes from "prop-types";
import swal from 'sweetalert';
import axios from 'axios';

import { GetFiliaisDetails } from '../../../../services';
import AutoSelect from "../../../../common/autoselect";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CFormLabel,
  CButton,
  CFormInput,
  CSpinner,
  CProgress,
  CProgressBar,
  CAlert
} from '@coreui/react';

const Arrays = (data, fieldName, fieldValue) => {
  let arrayItem = [];
  if (data && Array.isArray(data)) {
    data.map((item) => {
      arrayItem.push({ label: item[fieldName], value: item[fieldValue] });
      return null;
    });
  }
  return arrayItem;
};

export default class ImportarTabelaPrecos extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      getList: [],
      isLoaded: false,
      id_filial: "",
      nome_filial: "",
      arquivo: null,
      nomeArquivo: "",
      enviando: false,
      retorno: null,
      progresso: null,
      detalhamento: null,
      polling: false,
      progressFake: 0,
      progressLabel: "",
    };
  }

  async componentDidMount() {
    await this.getFiliais();
  }

  handleSelectChange = (name, selected) => {
    this.setState({
      list: {
        ...this.state.list,
        [name]: selected?.value,
      },
      id_filial: selected?.value || "",
      nome_filial: selected?.label || "",
    });
  };

  handleFileChange = (e) => {
    const file = e.target.files?.[0] || null;

    this.setState({
      arquivo: file,
      nomeArquivo: file?.name || "",
    });
  };

  async getFiliais() {
    this.setState({ isLoaded: true });
    let list = await GetFiliaisDetails.FilialList();
    if (list) {
      this.setState({ getList: list.data || [] });
    }
    this.setState({ isLoaded: false });
  }

  startFakeProgress = () => {
  this.stopFakeProgress();

  this.setState({
    progressFake: 3,
    progressLabel: "Iniciando envio da planilha...",
    polling: true,
    progresso: {
      totalItens: 0,
      sucesso: 0,
      erros: 0,
      processados: 0,
      percentual: 3,
      status: "PROCESSANDO",
    },
  });

  this.fakeProgressTimer = setInterval(() => {
    this.setState((prevState) => {
      const atual = prevState.progressFake || 0;
      let proximo = atual;

      if (atual < 15) proximo += 4;
      else if (atual < 35) proximo += 3;
      else if (atual < 55) proximo += 2;
      else if (atual < 75) proximo += 1;
      else if (atual < 90) proximo += 0.5;
      else proximo = atual;

      proximo = Math.min(90, Math.round(proximo));

      let label = "Enviando planilha...";
      if (proximo >= 15) label = "Validando arquivo e iniciando processamento...";
      if (proximo >= 35) label = "Processando tabela de preços...";
      if (proximo >= 55) label = "Atualizando itens na OMIE...";
      if (proximo >= 75) label = "Finalizando processamento...";
      if (proximo >= 90) label = "Aguardando resposta final da API...";

      return {
        progressFake: proximo,
        progressLabel: label,
        progresso: {
          ...(prevState.progresso || {}),
          percentual: proximo,
          status: "PROCESSANDO",
        },
      };
    });
  }, 1200);
};

stopFakeProgress = () => {
  if (this.fakeProgressTimer) {
    clearInterval(this.fakeProgressTimer);
    this.fakeProgressTimer = null;
  }
};

  EnviarPlanilha = async (event) => {
    event.preventDefault();

    const { id_filial, nome_filial, arquivo } = this.state;

    if (!id_filial) {
      swal("Aviso!", "Por favor, escolha uma filial!", "warning");
      return;
    }

    if (!arquivo) {
      swal("Aviso!", "Por favor, selecione a planilha!", "warning");
      return;
    }

    const extensaoValida =
      arquivo.name.toLowerCase().endsWith(".xlsx") ||
      arquivo.name.toLowerCase().endsWith(".xls");

    if (!extensaoValida) {
      swal("Aviso!", "Selecione um arquivo Excel (.xlsx ou .xls).", "warning");
      return;
    }

    swal({
      title: `Deseja importar a tabela de preços para ${nome_filial}?`,
      text: arquivo.name,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (success) => {
      if (!success) return;

      try {
        //this.setState({ enviando: true, retorno: null });
        this.setState({
          enviando: true,
          retorno: null,
          detalhamento: null,
        });

        this.startFakeProgress();

        const formData = new FormData();
        formData.append("file", arquivo);
        formData.append("cd_estabelecimento", String(id_filial));

        const response = await axios.post(
          "https://integradorbaoba.masterdaweb.net/api/tabelapreco/Importar",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const retorno = response.data || {};

        this.stopFakeProgress();

        this.setState({
          progressFake: 100,
          progressLabel: "Processamento concluído com sucesso.",
          progresso: {
            totalItens: retorno?.totalItens ?? 0,
            sucesso: retorno?.sucesso ?? 0,
            erros: retorno?.erros ?? 0,
            processados: (retorno?.sucesso ?? 0) + (retorno?.erros ?? 0),
            percentual: 100,
            status: retorno?.erros > 0 ? "CONCLUIDO_COM_ERROS" : "CONCLUIDO",
          },
          polling: false,
        });

        this.setState({
          retorno,
          enviando: false,
          progresso: null,
          detalhamento: null,
        });

        // if (retorno?.logFile) {
        //   this.iniciarPollingExecucao(retorno.logFile);
        // }

        swal("Sucesso!", "Planilha enviada com sucesso.", "success");
      } catch (error) {
        this.setState({ enviando: false });

        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Erro ao importar tabela de preços.";

        this.stopFakeProgress();

        this.setState({
          polling: false,
          progressLabel: "Erro no processamento.",
          progresso: {
            totalItens: 0,
            sucesso: 0,
            erros: 1,
            processados: 0,
            percentual: 100,
            status: "ERRO",
          },
        });  
        swal("Erro!", msg, "error");
      }
    });
  };

    componentWillUnmount() {
    this.stopPollingExecucao();
    this.stopFakeProgress();
  }

  stopPollingExecucao = () => {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  };

  iniciarPollingExecucao = (logFile) => {
    if (!logFile) return;

    this.stopPollingExecucao();

    this.setState({ polling: true });

    const carregar = async () => {
      try {
        const response = await axios.get(
          "https://integradorbaoba.masterdaweb.net/api/tabelapreco/getDetalheCTRLTabelaPrecos",
          {
            params: { logFile },
          }
        );

        const detalhe = response.data || {};
        const resumo = detalhe?.resumo || {};

        const totalItens = Number(resumo?.totalItens || 0);
        const sucesso = Number(resumo?.sucesso || 0);
        const erros = Number(resumo?.erros || 0);
        const processados = sucesso + erros;

        const percentual =
          totalItens > 0
            ? Math.min(100, Math.round((processados / totalItens) * 100))
            : 5;

        this.setState({
          detalhamento: detalhe,
          progresso: {
            totalItens,
            sucesso,
            erros,
            processados,
            percentual,
            status: resumo?.status || "PROCESSANDO",
          },
        });

        if (["CONCLUIDO", "CONCLUIDO_COM_ERROS", "ERRO"].includes(resumo?.status)) {
          this.stopPollingExecucao();
          this.setState({ polling: false });
        }
      } catch (error) {
        // mantém silencioso para não poluir a UX
      }
    };

    carregar();
    this.pollingTimer = setInterval(carregar, 4000);
  };

  render() {
    const {
      getList,
      isLoaded,
      nomeArquivo,
      enviando,
      retorno,
      progresso,
      detalhamento,
      polling,
      progressFake,
      progressLabel,
    } = this.state;

    const headerStyles = { display: "flex", justifyContent: "space-between" };

    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader style={headerStyles}>
              <strong>Importar Tabela de Preços OMIE</strong>
            </CCardHeader>

            <CCardBody>
              {isLoaded ? (
                <CSpinner />
              ) : (
                <form onSubmit={this.EnviarPlanilha}>
                  <CRow className="align-items-end">
                    <CCol md={4}>
                      <CFormLabel><strong>Escolha uma Filial</strong></CFormLabel>
                      <AutoSelect
                        className="basic-single"
                        onChange={this.handleSelectChange}
                        isSearchable={true}
                        name="id_filial"
                        label="Escolha uma Filial"
                        options={Arrays(getList, "nome", "cd_estabelecimento")}
                      />
                    </CCol>

                    <CCol md={5}>
                      <CFormLabel><strong>Selecione a Planilha</strong></CFormLabel>
                      <CFormInput
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={this.handleFileChange}
                      />
                      {nomeArquivo ? (
                        <div style={{ marginTop: 8, fontSize: 13 }}>
                          <strong>Arquivo:</strong> {nomeArquivo}
                        </div>
                      ) : null}
                    </CCol>

                    <CCol md={3}>
                      <CButton
                        color="primary"
                        type="submit"
                        style={{ marginTop: 24 }}
                        disabled={enviando}
                      >
                        {enviando ? "Enviando..." : "Enviar Planilha"}
                      </CButton>
                    </CCol>
                  </CRow>
                </form>
              )}
            </CCardBody>
          </CCard>
        </CCol>

                {progresso && (
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>Acompanhamento da Execução</strong>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={3}>
                    <strong>Status</strong><br />
                    {progresso.status}
                  </CCol>

                  <CCol md={3}>
                    <strong>Processados</strong><br />
                    {progresso.processados} / {progresso.totalItens}
                  </CCol>

                  <CCol md={3}>
                    <strong>Sucesso</strong><br />
                    {progresso.sucesso}
                  </CCol>

                  <CCol md={3}>
                    <strong>Erros</strong><br />
                    {progresso.erros}
                  </CCol>
                </CRow>

                <CProgress className="mb-2" height={20}>
                  <CProgressBar value={progresso.percentual}>
                    {progresso.percentual}%
                  </CProgressBar>
                </CProgress>

                <div style={{ fontSize: 13, marginTop: 6 }}>
                  {progressLabel}
                </div>

                {polling ? (
                  <CAlert color="info" className="mb-0">
                    {progresso?.status === "ENVIANDO_PLANILHA"
                      ? "Enviando planilha e aguardando início do processamento..."
                      : "A importação está em andamento. A tela está atualizando automaticamente."}
                  </CAlert>
                ) : (
                  <CAlert color={progresso.erros > 0 ? "warning" : "success"} className="mb-0">
                    Execução finalizada.
                  </CAlert>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        )}

               {retorno && (
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>Resultado da Importação</strong>
              </CCardHeader>
              <CCardBody>
                <CRow className="mb-3">
                  <CCol md={4}>
                    <strong>Tabela</strong><br />
                    {retorno?.tabela?.nome || "-"}
                  </CCol>
                  <CCol md={4}>
                    <strong>Código OMIE</strong><br />
                    {retorno?.tabela?.nCodTabPreco || "-"}
                  </CCol>
                  <CCol md={4}>
                    <strong>Ação</strong><br />
                    {retorno?.tabela?.acao || "-"}
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={3}>
                    <strong>Total Itens</strong><br />
                    {retorno?.totalItens ?? 0}
                  </CCol>
                  <CCol md={3}>
                    <strong>Sucesso</strong><br />
                    {retorno?.sucesso ?? 0}
                  </CCol>
                  <CCol md={3}>
                    <strong>Erros</strong><br />
                    {retorno?.erros ?? 0}
                  </CCol>
                  <CCol md={3}>
                    <strong>Total de Lotes</strong><br />
                    {retorno?.batch?.totalBatches ?? 0}
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <strong>Arquivo de Log</strong><br />
                    {retorno?.logFile || "-"}
                  </CCol>
                  <CCol md={6}>
                    <strong>Status Final</strong><br />
                    {retorno?.erros > 0 ? "Concluído com erros" : "Concluído com sucesso"}
                  </CCol>
                </CRow>

                {retorno?.errors?.length > 0 && (
                  <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                    {JSON.stringify(retorno.errors, null, 2)}
                  </pre>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        )}
      </CRow>
    );
  }
}